import React, { useEffect } from "react";
import { useHistory } from "react-router-dom";
import Index from "./index";
import Functions from "../../src/functions";
import Manager from "../../src/manager";
import "../../src/config";
import { matchPath } from "react-router";

const RouterMap = window["fw_routerMap"];

function createTab(position, pathname, module, view, parameters) {
  let key = Functions.md5(pathname);

  switch (position) {
    case "main":
      window["index"].setState({
        main: [
          <Manager
            module={module}
            view={view}
            pathname={pathname}
            key={key}
            keyprop={key}
            customParameters={parameters}
            ref={(refComponent) => {
              window[position + "ref" + key] = refComponent;
            }}
          />,
        ],
      });
      break;

    default:
      window["index"].setState({
        [position]: [
          <Manager
            module={module}
            pathname={pathname}
            view={view}
            key={Functions.key()}
            keyprop={key}
            customParameters={parameters}
            ref={(refComponent) => {
              window[position + "ref"] = refComponent;
            }}
          />,
        ],
      });
      break;
  }
}

function getRouter(routerMapper, history) {
  // let routerBestMatch = stringSimilarity.findBestMatch(
  //   history.location.pathname,
  //   Object.keys(routerMapper)
  // ).bestMatch.target;
  let routerBestMatch = "";
  const routes = Object.keys(routerMapper).filter((item) => {
    return matchPath(
      {
        path: item,
        exact: true,
      },
      history.location.pathname
    );
  });

  if (routes.length > 1) {
    routerBestMatch = routes.filter((itm, idx) => {
      return itm == history.location.pathname;
    });
  } else {
    routerBestMatch = routes[0];
  }

  let routerMapperBestMatch = routerMapper[routerBestMatch];

  Object.keys(routerMapperBestMatch).map((itm, idx) => {
    let parameters = null;
    let module = null;
    let view = null;
    if (routerMapperBestMatch[itm]) {
      if (routerMapperBestMatch[itm]["parameters"]) {
        parameters = routerMapperBestMatch[itm]["parameters"]();
      }
      if (routerMapperBestMatch[itm]["customParameters"]) {
        parameters = routerMapperBestMatch[itm]["customParameters"];
      }

      module = routerMapperBestMatch[itm]["module"];
      view = routerMapperBestMatch[itm]["view"];

      if (module != "dashboard") {
        createTab(itm, history.location.pathname, module, view, parameters);
      }
    } else {
      window["index"].setState({
        [itm]: [],
      });
    }
  });
}

const FW_Router = () => {
  const history = useHistory();

  let hasHistory = false;

  useEffect(() => {
    if (!hasHistory) {
      if (RouterMap) {
        getRouter(RouterMap, history);
      }
    }
    return history.listen((location) => {
      hasHistory = true;
      if (RouterMap) {
        getRouter(RouterMap, history);
      }
    });
  }, [history]);

  return (
    <Index
      key={Functions.key()}
      history={history}
      ref={(refComponent) => {
        window["index"] = refComponent;
      }}
    ></Index>
  );
};

export default FW_Router;
